import enCA from './locales/en-CA/common.json';
import enUS from './locales/en-US/common.json';
import frCA from './locales/fr-CA/common.json';
import esUS from './locales/es-US/common.json';
import type { Locale } from './locales';

export const defaultNamespace = 'common';

/** en-CA is the reference locale: every other locale must have exactly its keys. */
export type CommonMessages = typeof enCA;

export const resources = {
  'en-CA': { common: enCA },
  'fr-CA': { common: frCA },
  'en-US': { common: enUS },
  'es-US': { common: esUS },
} as const satisfies Record<Locale, { common: CommonMessages }>;

// Typing the resources makes a missing or misspelt key a type error at every call site.
declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: typeof defaultNamespace;
    resources: { common: CommonMessages };
  }
}
